import { defineStore } from 'pinia';
import { ref } from '@nuxtjs/composition-api';

export const useUserInQuarantineStore = defineStore('userInQuarantineStore', () => {
  const isUserInQuarantine = ref(false)
  const fullPriceMOProratedPrice = ref(0)
  const fullPriceSubscriptionName = ref(null)
  return {
    fullPriceSubscriptionName,
    fullPriceMOProratedPrice,
    isUserInQuarantine
  }
})
